import { Grid, Paper, TextField } from '@material-ui/core';
import React from 'react';
import { productsEntryManagementStore } from 'stores/productsEntryManagement.store';
import shallow from 'zustand/shallow';

export default function ImProductEntryManagementHeader() {
  const [headerData, setHeaderData, isLoadingSave] = productsEntryManagementStore(
    (state) => [state.headerData, state.setHeaderData, state.isLoadingSave],
    shallow
  );
  return (
    <Paper style={{ padding: '20px 0' }}>
      <Grid container justify="space-evenly">
        <Grid item xs={12} md={5}>
          <TextField
            required
            variant="outlined"
            margin="dense"
            fullWidth
            name="purchaseOrder"
            label="Número de orden"
            value={headerData.purchaseOrder}
            onChange={(e) => setHeaderData({ ...headerData, purchaseOrder: e.target.value })}
            autoComplete="off"
            disabled={isLoadingSave}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            variant="outlined"
            margin="dense"
            fullWidth
            name="remission"
            label="Remisión"
            value={headerData.remission}
            onChange={(e) => setHeaderData({ ...headerData, remission: e.target.value })}
            autoComplete="off"
            disabled={isLoadingSave}
          />
        </Grid>
      </Grid>
      <Grid container justify="space-evenly">
        <Grid item xs={12} md={5}>
          <TextField
            required
            variant="outlined"
            margin="dense"
            fullWidth
            name="invoice"
            label="Factura"
            value={headerData.invoice}
            onChange={(e) => setHeaderData({ ...headerData, invoice: e.target.value })}
            autoComplete="off"
            disabled={isLoadingSave}
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <TextField
            variant="outlined"
            margin="dense"
            fullWidth
            name="observations"
            label="Observaciones"
            multiline
            rows={3}
            value={headerData.observations}
            onChange={(e) => setHeaderData({ ...headerData, observations: e.target.value })}
            autoComplete="off"
            disabled={isLoadingSave}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
